import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=aa6bd4ec&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa6bd4ec')) {
      api.createRecord('aa6bd4ec', component.options)
    } else {
      api.reload('aa6bd4ec', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=aa6bd4ec&", function () {
      api.rerender('aa6bd4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XIXAN5488smZ/JS/comp/childrenage.vue"
export default component.exports